import opencv from "@soscomp/opencv"

export default opencv
